/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { defineMutation } from 'pulse/mutations';
import { RpcError } from 'pulse/adapters';
import * as References from './ThreadAccessGrantRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

// RPC Mutations

export const GrantThreadAccessMutation = defineMutation({
  typeName: 'com.hubspot.support.portal.rpc.ThreadAccessGrantRpc.grantThreadAccess',
  mutation: params => chirpClient.callWithResultUnion(References.grantThreadAccessRpc, {
    request: params
  }).then(result => {
    if (result.type === 'rpcError') throw new RpcError(result.rpcError);
    return result.data;
  })
});